import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { motion } from "framer-motion";

const AboutIsland = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-100 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Left: Text Content */}
          <motion.div 
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="flex flex-col"
          >
            <p className="text-sm font-semibold tracking-widest uppercase text-tropical-500 mb-3 font-display">
              The Island
            </p>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-ink-900 font-display mb-8">
              About <br className="hidden sm:block" /> St. John, USVI
            </h2>
            
            <p className="text-ink-600 text-lg mb-8 leading-relaxed font-light">
              St. John is the smallest and most pristine of the three main US Virgin Islands. With two-thirds of the island designated as a National Park, it offers an unmatched combination of untouched natural beauty, tranquility, and exclusive real estate opportunities.
            </p>

            <ul className="space-y-4 mb-10">
              {[
                "7,000+ acres of Virgin Islands National Park",
                "Over 30 pristine white-sand beaches",
                "World-class diving, sailing & snorkeling",
                "Award-winning restaurants & vibrant culture"
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-4">
                  <div className="bg-tropical-50 text-tropical-600 p-1.5 rounded-full shrink-0">
                    <Check className="w-4 h-4" />
                  </div>
                  <span className="text-ink-700 font-medium">{item}</span>
                </li>
              ))}
            </ul>

            <div>
              <a 
                href="https://340realestate.com/about"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-ink-900 font-bold hover:text-tropical-600 transition-colors group"
              >
                Explore the Island 
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </motion.div>

          {/* Right: Image & Stats */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="aspect-[4/3] sm:aspect-square lg:aspect-[4/5] rounded-[2rem] overflow-hidden relative">
              <img 
                src="https://340realestate.com/_next/image?url=%2Fassets%2Fslh3.jpg&w=1080&q=75" 
                alt="St. John USVI View" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-ink-900/10"></div>
            </div>

            {/* Floating Stat Card */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="absolute -bottom-8 -left-8 sm:-bottom-12 sm:-left-12 bg-white rounded-2xl p-6 sm:p-8 shadow-2xl border border-gray-100 max-w-[280px]"
            >
              <p className="text-xs font-bold tracking-widest text-tropical-500 uppercase mb-2">St. John USVI</p>
              <p className="text-4xl font-bold text-ink-900 font-display mb-1">60%</p>
              <p className="text-ink-600 text-sm font-medium">National Park & Protected Land</p>
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutIsland;
